import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Segnalazione } from '../models/segnalazione.model';
import { Intervento } from '../models/intervento.model';


@Injectable({
  providedIn: 'root',
})
export class InterventiService{
  apiUrl: string = environment.apiUrl+"intervento";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

  get(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }
  getByID(idIntervento:string): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+idIntervento, httpOptions);
  }

  getLast5(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?filter=last5", httpOptions);
  }

  getLastNuove(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?filter=lastNew5", httpOptions);
  }


  getByTecnicoAndDataInizio(idTecnico:number): Observable<any> {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // I mesi in JavaScript vanno da 0 a 11
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?tecnico="+idTecnico+"&data_inizio="+formattedDate, httpOptions);
  }

  getStorico(inIntervento:number): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+inIntervento+"/storico", httpOptions);
  }
  crea(intervento:Intervento): Observable<any> {

    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, intervento, httpOptions);
  }



  elimina(idIntervento:string): Observable<any> {
    let url = this.apiUrl +"/"+idIntervento;
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(url, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminasegnalazione', []))
    );
  }
  modifica(intervento:Intervento): Observable<any> {

    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+intervento.id, intervento, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificasegnalazione', []))
    );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };
}
